<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="handleClose"  width="80%">
    <div style="color: red;font-weight: bold">正在使用：<span >{{isWorking}}</span></div>
    <el-table
      :data="tableData"
      height="500"
      border
      :header-cell-style="{background:'#66b1ff',color:'#fff'}"
      style="width: 100%">
      <el-table-column prop="typeName" label="办学形式" align="center" ></el-table-column>
      <el-table-column prop="majorName" label="专业名称" align="center"></el-table-column>
      <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
      <el-table-column prop="courseCode" label="课程代码" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center"></el-table-column>
      <el-table-column prop="syTime" label="使用时间" align="center"></el-table-column>
      <el-table-column prop="dqTime" label="到期时间" align="center"></el-table-column>
      <el-table-column prop="term" label="使用时间（天）" align="center"></el-table-column>
    </el-table>
    <span slot="footer" style="width: 100%;display: inline-block;text-align: center">
      <el-button type="primary" @click="submitForm">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import * as api from '@/api/courseware/checkCourseware'
import { http } from '@/utils/axios'
export default {
  name: 'CoursewareManagerAnalysis',
  data () {
    return {
      isWorking:'2',
      visible: false,
      tableData: [],
      title:'',


    }
  },
  methods: {
    // 初始化
    init (id,title) {
      this.visible = true
      this.title =title +'的使用情况'
      api.getListCites(id).then(({ data }) => {
        if(data.code == 100000){
          data = data.data
          console.log(data)
          this.tableData = data.list
          this.getNums()
        }else {
          this.$message({ type: 'error', message: data.msg })
        }
      })


    },

    getNums(){
      var num = 0;
      console.log(this.tableData);
      for (let i = 0; i < this.tableData.length; i++) {
        if(this.tableData[i].status == '正在使用'){
          num++
        }
      }
      this.isWorking = num
    },

    // 获取用户简表文件
    getUserFile (idCard) {

    },


    // 处理弹窗关闭事件
    handleClose (msg) {
      this.visible = false
      // this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm () {
      this.visible = false
      // this.$emit('close-registration-review-edit', msg)
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  @include flex(center, flex-start);
  .info{
    width: 50%;
    border-right: 1px solid  #4e5359;
    &:nth-last-child(1){
      border-right: none;
    }
    .info-title{
      @include font(18px,  #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form{
    .el-form-item{
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>

</style>
